import styled from 'styled-components';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import type { IconButtonStylesProps } from '@web-chat-core/ui-kit';
import { Icon, Typography } from '@web-chat-core/ui-kit';

export const DropdownMenu = DropdownMenuPrimitive.Root;
export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;

export const HoverBridge = styled.span<{ $sideOffset: number }>`
    position: absolute;
    pointer-events: auto;

    [data-side='bottom'] > & {
        top: -${p => p.$sideOffset}px;
        left: 0;
        right: 0;
        height: ${p => p.$sideOffset}px;
    }

    [data-side='top'] > & {
        bottom: -${p => p.$sideOffset}px;
        left: 0;
        right: 0;
        height: ${p => p.$sideOffset}px;
    }

    [data-side='left'] > & {
        right: -${p => p.$sideOffset}px;
        top: 0;
        bottom: 0;
        width: ${p => p.$sideOffset}px;
    }

    [data-side='right'] > & {
        left: -${p => p.$sideOffset}px;
        top: 0;
        bottom: 0;
        width: ${p => p.$sideOffset}px;
    }
`;

export const DropdownMenuContent = styled(DropdownMenuPrimitive.Content)<{ $withoutShadow?: boolean }>`
    box-sizing: border-box;
    min-width: 220px;
    padding: 8px 0;
    border-radius: 8px;
    background: ${props => props.theme.root.colors.background['02Second']};
    box-shadow: ${props =>
        props.$withoutShadow
            ? 'none'
            : '0 10px 38px -10px rgba(22, 23, 24, 0.35), 0 10px 20px -15px rgba(22, 23, 24, 0.2)'};
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: auto;
    z-index: 1000;
    font-size: 14px;

    &[data-state='open'] {
        &[data-side='top'] {
            animation-name: slideDownAndFade;
        }

        &[data-side='right'] {
            animation-name: slideLeftAndFade;
        }

        &[data-side='bottom'] {
            animation-name: slideUpAndFade;
        }

        &[data-side='left'] {
            animation-name: slideRightAndFade;
        }
    }

    @keyframes slideUpAndFade {
        from {
            opacity: 0;
            transform: translateY(2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideRightAndFade {
        from {
            opacity: 0;
            transform: translateX(-2px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @keyframes slideDownAndFade {
        from {
            opacity: 0;
            transform: translateY(-2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideLeftAndFade {
        from {
            opacity: 0;
            transform: translateX(2px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
`;

export const DropdownMenuItem = styled(DropdownMenuPrimitive.Item)`
    padding: 8px 14px;
    outline: none;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s ease;

    &[data-highlighted] {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &:hover {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &[data-disabled] {
        pointer-events: none;
        opacity: 0.5;
    }
`;

export const MenuButton = styled.button<IconButtonStylesProps>`
    background-color: transparent;
`;

export const MenuItemContent = styled(Typography)`
    display: flex;
    align-items: center;
    line-height: 24px;

    ${Icon} {
        margin-right: 8px;
    }
`;

export const MenuItemDisabled = styled.div`
    padding: 8px 16px;
    pointer-events: none;
    cursor: not-allowed;

    ${MenuItemContent} {
        color: ${props => props.theme.root.colors.basicColors['25%']};

        svg {
            fill: ${props => props.theme.root.colors.basicColors['25%']};
        }

        span {
            color: ${props => props.theme.root.colors.basicColors['25%']};
        }
    }

    ${Icon} {
        svg {
            path {
                fill: ${props => props.theme.root.colors.basicColors['25%']};
            }
        }
    }
`;
